/* RESPONSIBLE TEAM: team-proactive-support */
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

export default class SelectionSet extends Model {
  @attr('date') createdAt;
  @belongsTo('content-service/content-object', { async: false, polymorphic: true }) object;
  @hasMany('outbound/content-statistic', { async: false }) objectStats;
}
